const FIRM_INVITATION_PATH = "/firm-invitation";

export { FIRM_INVITATION_PATH };
